import { Values } from "../PlanDetailsApp/pages/PlanPaymentPage/components/types";

type Price = `${number}.${number}${number}`;

export const priceFromCoupon = (
  fullPrice: number,
  coupon: Values["coupon"],
): Price => {
  let price = fullPrice;

  if (coupon) {
    if (coupon.amount_off) {
      price -= coupon.amount_off / 100;
    } else if (coupon.percent_off) {
      price -= (price * coupon.percent_off) / 100;
    }
  }

  // Rounds to nearest cent
  price = Math.round(price * 100) / 100;

  return `${price.toFixed(2)}` as Price; // adding .00 for whole nums
};

export const discountFromCoupon = (
  fullPrice: number,
  coupon: Values["coupon"],
): Price => {
  let price = fullPrice;

  if (coupon) {
    if (coupon.amount_off) {
      price -= coupon.amount_off / 100;
    } else if (coupon.percent_off) {
      price -= (price * coupon.percent_off) / 100;
    }
  }

  // Rounds to nearest cent
  const difference = Math.round((fullPrice - price) * 100) / 100;

  return `${difference.toFixed(2)}` as Price; // adding .00 for whole nums
};
